var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({class:['xpb-no-data-wrap', _vm.size, _vm.isFull ? 'xpb-no-data-wrap--full' : '']},_vm.$listeners),[_c('Icon',{staticClass:"xpb-no-data-wrap__img",attrs:{"iconClass":"xpb-no-data"}}),_c('div',{staticClass:"message",domProps:{"innerHTML":_vm._s(_vm.message || _vm.t('xpb.noData'))}}),_vm._t("extraContent")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }